import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHome } from '@fortawesome/free-solid-svg-icons';
import styled from '@emotion/styled';

import { Container } from 'components/layout';
import { ProgressTracker } from 'components/checkout';
import { useIsCheckoutPage } from 'utils/hooks';

const BreadcrumbContainer = styled(Container)`
  height: 5.72rem;
  position: relative;

  .svg-inline--fa {
    color: ${({ theme }) => theme.colors.action};
    cursor: pointer;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    width: 1.29rem;
    height: 1.29rem;

    &:hover {
      color: ${({ theme }) => theme.colors.actionStrong};
    }
  }
`;

const Breadcrumb = () => {
  const history = useHistory();
  const { pathname } = useLocation();
  const isCheckoutPage = useIsCheckoutPage();

  const hideHomeIcon = ['/cases', '/cases/new/confirmation'].includes(pathname);

  return isCheckoutPage ? (
    <ProgressTracker />
  ) : (
    <BreadcrumbContainer>
      {!hideHomeIcon && (
        <FontAwesomeIcon onClick={() => history.push('/cases')} icon={faHome} />
      )}
    </BreadcrumbContainer>
  );
};

export { Breadcrumb };
